import { ShopWishlist } from './wishlist.js';

export class ShopWishlistButton extends HTMLElement {
  wishlist = new ShopWishlist();

  async connectedCallback() {
    if (this.hasAttribute('[data-no-listener]')) return;
    // Initialize the button state
    const handle = this.getAttribute('data-handle');
    const added = await this.wishlist.hasEntry(handle);
    if (added) {
      this.setAttribute('data-wishlist-added', true);
    } else {
      this.setAttribute('data-wishlist-added', false);
    }

    // Button click handler
    this.addEventListener('click', async () => {
      const handle = this.getAttribute('data-handle');
      const added = await this.wishlist.hasEntry(handle);
      if (added) {
        this.wishlist.removeEntry(handle);
        this.setAttribute('data-wishlist-added', false);
      } else {
        this.wishlist.addEntry(handle);
        this.setAttribute('data-wishlist-added', true);
      }
    });
  }
}
if (!customElements.get('shop-wishlist-button')) {
  customElements.define('shop-wishlist-button', ShopWishlistButton);
}
